'use strict';
// TODO: Remove from `core-js@4`
require('../modules/es.promise.all-settled.js');



//////////////////
// WEBPACK FOOTER
// ./~/core-js-pure/modules/esnext.promise.all-settled.js
// module id = 736
// module chunks = 13